// CourseBuyers.jsx
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import BASE_URL from "../../../config/config";
import DateDisplay from "../../common/DateDisplay"; // اگر کامپوننت دارید
// import '../../../css/CourseBuyers.module.css'/

const CourseBuyers = () => {
  const { courseId } = useParams();
  const [buyers, setBuyers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBuyers = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/courses/${courseId}/buyers`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            credentials: "include",
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch buyers");
        }

        const data = await response.json();
        setBuyers(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBuyers();
  }, [courseId]);

  if (loading) {
    return <div>در حال بارگذاری...</div>;
  }

  if (error) {
    return <div>خطا: {error}</div>;
  }

  return (
    <div className="course-buyers-container">
      <h2>خریداران دوره</h2>
      {buyers.length === 0 ? (
        <div>هیچ خریداری برای این دوره یافت نشد.</div>
      ) : (
        <table className="buyers-table">
          <thead>
            <tr>
              <th>شناسه کاربر</th>
              <th>نام کاربری</th>
              {/* <th>ایمیل</th> */}
              <th>تاریخ خرید</th>
              <th>نام دوره</th> {/* ستون نام دوره */}
            </tr>
          </thead>
          <tbody>
            {buyers.map((buyer) => (
              <tr key={buyer.id}>               
                <td>
                  <Link to={`/admin/users/edit/${buyer.id}`}>
                    {buyer.id}
                  </Link>
                </td>
                <td>{buyer.username}</td>
                {/* <td>{buyer.email}</td> */}
                <td>
                  <DateDisplay isoDate={buyer.created_at} /> {/* نام فیلد دیت*/}
                </td>
                <td>
                  <Link to={`/admin/courses/edit/${buyer.course_id}`}>
                    {buyer.course_title}
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CourseBuyers;